// extracted by mini-css-extract-plugin
export var content = "_62-3";
export var list = "_62-4";
export var settingsContent = "_62-7";
export var settingsPanel = "_62-8";
export var state = "_62-6";
export var triggerBadge = "_62-2";
export var triggerButton = "_62-1";
export var triggerShell = "_62-0";
export var unreadDot = "_62-5";